import React from 'react';
import styled, { css } from 'styled-components';

import { convertThumbnailToPictureProps } from '@tager/web-modules';

import Picture from '@/components/Picture';
import { media } from '@/utils/mixin';

import { CarSelectionHelperCardProps } from './types';

function CarSelectionHelperCard({
  image,
  onClick,
}: CarSelectionHelperCardProps) {
  return (
    <Component onClick={onClick}>
      <Image loading="lazy" {...convertThumbnailToPictureProps(image)} />
    </Component>
  );
}

export default CarSelectionHelperCard;

const Component = styled.button`
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 138.894%;

  ${media.laptop(css`
    padding-top: 157.811%;
  `)}

  ${media.tablet(css`
    padding-top: 150.999%;
  `)}

  ${media.tabletSmall(css`
    padding-top: 130.671%;
  `)}

  ${media.mobile(
    css`
      padding-top: 138.894%;
    `
  )}
`;

const Image = styled(Picture)`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;

  picture,
  img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
  }

  img {
    object-fit: cover;
  }
`;
